import { render, staticRenderFns } from "./ArticleLabel.vue?vue&type=template&id=678604d1&scoped=true"
import script from "./ArticleLabel.vue?vue&type=script&lang=js"
export * from "./ArticleLabel.vue?vue&type=script&lang=js"
import style0 from "./ArticleLabel.vue?vue&type=style&index=0&id=678604d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678604d1",
  null
  
)

export default component.exports